// @flow
import React from 'react'

const Header = (props: {pageTitle: string}): React$Element<'div'> => (
  <div className='page-title'>
    <div className='wrapper-content'>
      <h2>{props.pageTitle}</h2>
    </div>
  </div>
)

export default Header
window.Components.Header = React.createFactory(Header)



// WEBPACK FOOTER //
// ./app/javascript/packs/components/shared/Header.js